import { COLLECTION_ID } from 'modules/collection/constants'

const STOCKING_STUFFER_MAX_PRICE = 10

/**
 * @param price
 * @param collectionId
 * @param isHolidayGiftsUrl
 * @param isMini
 * @returns {Boolean}
 */
const hasStockingStufferBadgeProductVariantSelectorUtil = ({
  price,
  collectionId,
  isHolidayGiftsUrl,
  isMini
}) => {
  return !!(
    isHolidayGiftsUrl &&
    (
      price < STOCKING_STUFFER_MAX_PRICE ||
      isMini
    ) &&
    collectionId &&
    collectionId !== COLLECTION_ID.HOLIDAY_GIFTS_UNDER_10_DOLLARS
  )
}

export default hasStockingStufferBadgeProductVariantSelectorUtil
